import { useSearchParams } from 'react-router-dom'
import { campaignHooks } from 'features/campaigns'
import { Param } from 'shared/search-adapters'

import { getTagText, type TagItem } from './utils'

export function usePrepareTags(order: Param[]) {
	const [params, setParams] = useSearchParams()
	const { campaign } = campaignHooks.useCurrent()

	const tags = order.reduce<TagItem[]>((results, key) => {
		const text = getTagText(params, key, campaign?.steps)

		if (text) {
			results.push({
				clear: () =>
					setParams(prev => {
						prev.delete(Param.Skip)
						prev.delete(key)
						return prev
					}),
				key,
				text
			})
		}

		return results
	}, [])

	const clearAllFilters = () =>
		setParams(params => {
			params.delete(Param.Skip)
			params.delete(Param.ModalSkip)
			for (const key of order) {
				params.delete(key)
			}

			return params
		})

	return {
		clearAllFilters,
		tags
	}
}
